module.exports = __webpack_public_path__ + "static/young-leader-photo-diksha_shukla-c74dabd33a1eb478030d41f3042c5e0e.jpg";